import React from 'react';
import AppShell from '../components/layout/AppShell';
import CaseFeed from '../features/cases/components/CaseFeed';

const FeedPage = () => {
  return (
    <AppShell>
      <CaseFeed />
    </AppShell>
  );
};

export default FeedPage;
